import * as d3 from 'd3'
import createPortal from './createPortal'
import createLayout from './createLayout'
import createNode from '@/views/Scenario/draw/createNode'
import createLink from '@/views/Scenario/draw/createLink'
import createTitle from '@/views/Scenario/draw/createTitle'
import { actionTypes } from '@/store/store.type'
import store from '@/store/store'

function draw (dataBus) {
    let {
        zoom,
        svgPadding,
        cellWidth,
        cellHeight
    } = dataBus.graphConfig
    let {
        nodeList,
        linkList
    } = createPortal(dataBus)
    store.dispatch(actionTypes.scenario.GRAPH_NODE_LIST, nodeList)
    let {
        maxX,
        maxY,
        qnaTextY,
        aloneTextY
    } = createLayout(dataBus, nodeList, dataBus.graphConfig)
    maxX = Math.max(maxX, 2)
    maxY = Math.max(maxY, 2)
    let viewBoxWidth = svgPadding * 2 + cellWidth * (maxX + 1)
    let viewBoxHeight = svgPadding * 2 + cellHeight * (maxY + 1)
    let svg = d3.select('#' + dataBus.svgId)
        .attr('width', viewBoxWidth * zoom / 100)
        .attr('height', viewBoxHeight * zoom / 100)
        .attr('viewBox', [0, 0, viewBoxWidth, viewBoxHeight])
    let activeData = getActiveGraphNode(dataBus, nodeList)
    if (
        dataBus.activeGraphStepNodeId !== activeData.activeGraphStepNodeId ||
        dataBus.activeGraphCardNodeId !== activeData.activeGraphCardNodeId
    ) {
        dataBus.syncActiveGraphNode(activeData)
        return
    }
    createLink(dataBus, svg, linkList)
    createNode(dataBus, svg, nodeList)
    createTitle(dataBus, svg, qnaTextY, aloneTextY)
    shineLink(dataBus, nodeList)

    dataBus.syncViewBox({
        width: viewBoxWidth,
        height: viewBoxHeight
    })
}

function getActiveGraphNode (dataBus, nodeList) {
    let {
        activeGraphStepNodeId,
        activeGraphCardNodeId,
        activeCardCode,
        activeStepCode
    } = dataBus
    if (!activeCardCode && !activeStepCode) {
        return {
            activeGraphStepNodeId: null,
            activeGraphCardNodeId: null
        }
    }
    if (!activeGraphCardNodeId && activeCardCode) {
        let activeGraphCardNode = findNode(nodeList, activeCardCode)
        activeGraphCardNodeId = activeGraphCardNode ? activeGraphCardNode.id : null
    }
    if (!activeGraphStepNodeId && activeStepCode) {
        let activeGraphStepNode = findNode(nodeList, activeStepCode)
        activeGraphStepNodeId = activeGraphStepNode ? activeGraphStepNode.id : null
    }
    return {
        activeGraphStepNodeId,
        activeGraphCardNodeId
    }
}

function findNode (nodeList, id) {
    let node = null
    for (let item of nodeList) {
        if (item.data.id === id) {
            if (!item.isPortal) {
                node = item
                break
            }
            if (!node) {
                node = item
            }
        }
    }
    return node
}

function shineLink (dataBus, nodeList) {
    // remove highlight of all links
    d3.selectAll('.link').classed('shine', false)
    // list of active node
    let activeNodeList = []
    // card node
    let activeGraphCardNodeId = dataBus.activeGraphCardNodeId
    let node = activeGraphCardNodeId ? nodeList.find(node => node.id === activeGraphCardNodeId) : null
    if (node) {
        activeNodeList.push(node)
    }
    // step node
    let activeGraphStepNodeId = dataBus.activeGraphStepNodeId
    node = activeGraphStepNodeId ? nodeList.find(node => node.id === activeGraphStepNodeId) : null
    if (node) {
        activeNodeList.push(node)
    }
    // highlight link
    for (let node of activeNodeList) {
        let parent = node.parent
        while (parent) {
            d3.select(`#link-${parent.id}-${node.id}`).classed('shine', true).raise()
            node = parent
            parent = node.parent
        }
    }
}

export default draw
